import store from '~/js/store'
import axios from 'axios'

let getModalInfoById;

getModalInfoById = function(formId) {
  return axios.get('/bitrix/services/main/ajax.php', {
    params: {
      action: 'its:crabform.api.Modal.getForm',
      formId: formId
    }
  })
}

let show = function(inFormId) {
  let formId
  let modal
  let modalInfo


  formId = typeof inFormId === 'number' ? inFormId : this.dataset.formId
  modalInfo = getModalInfoById(formId)

  modalInfo.then(response => {
    let fields = response.data.data.fields
    let baseInfo = response.data.data.baseInfo

    modal = {
      show: true,
      title: baseInfo.NAME,
      submitText: baseInfo.BUTTON,
      successText: baseInfo.FORM_TEMPLATE ? baseInfo.FORM_TEMPLATE : 'Отправлено!',
      formId: baseInfo.ID,
      fields: [
      ],
      hiddenFields: [
      ]
    }

    let allFields = fields.map(function(field) {
      return {
        id: field.SID + 'field',
        type: field.CALC_FIELD_TYPE,
        placeholder: field.TITLE,
        ref: '',
        pattern: '',
        required: field.REQUIRED === 'Y' ? true: false,
        value: '',
        component: field.CALC_FIELD_TYPE,
        hidden: field.COMMENTS  === 'Y' ? true: false,
        name: field.html_field_name,
        error: false,
        errorText: ''
      };
    });

    modal['fields'] = allFields.filter(field => field.hidden === false)
    modal['hiddenFields'] = allFields.filter(field => field.hidden === true)

    store.commit('plainFormShow', modal)
  })
}

export default show
